import Vue from 'vue'
import Vuex from 'vuex'
import {API_URL} from '@/config'
import router from '@/router'

import {videoUpload} from "@/store/modules/videoUpload";

Vue.use(Vuex)

export default new Vuex.Store({
    state: {
        token: null,
        progress: false,
        response: {
            message: null,
            errors: [],
        },
        search: '',
        results: [],
        days: [],
        sessions: [],
        presentations: [],
        activeFilter : '',
        activeSupport : '+49 511 123 56 33 1'
    },
    getters: {
        activeFilter: state => state.activeFilter,
        activeSupport: state => state.activeSupport,
    },
    mutations: {
        setToken(state, token) {
            state.token = token
        },
        setProgress(state, progress) {
            state.progress = progress
        },
        setResponseMessage(state, message) {
            state.response.message = message
        },
        setResponseErrors(state, errors) {
            state.response.errors = errors
        },
        setDays(state, days) {
            state.days = days
        },
        setSessions(state, sessions) {
            state.sessions = sessions
        },
        setPresentations(state, presentations) {
            state.presentations = presentations
        },
        setActiveFilter(state,filter){
            state.activeFilter = filter;
        },
        setActiveSupport(state,support){
            state.activeSupport = support;
        }
    },
    actions: {
        getToken: async ({state, commit}, params) => {
            let token = null;
            try {
                token = await Vue.axios.get(API_URL + '/token', {
                    headers: {token: state.token},
                    params: params
                });
            } catch (error) {
                if (error.response.status === 422) {
                    commit('setProgress', false);
                    commit('setResponseMessage', error.response.data.message);
                    commit('setResponseErrors', error.response.data.errors);
                    return;
                } else if (error.response.status === 404) {
                    commit('setProgress', false);
                    commit('setResponseMessage', 'The given data was either invalid or didn\'t grant access');
                    return;
                } else {
                    router.push('/error');
                }
            }
            if (token) {
                sessionStorage.setItem('token', token.data);
                commit('setToken', token.data);
                router.push('/days');
            }
        },
        removeToken: ({commit}) => {
            sessionStorage.removeItem('token');
            commit('setToken', null);
            router.push('/login');
        },
        searchItems: async ({state, commit}) => {
          console.log(state.search);
          let results = null;
          try {
              results = await Vue.axios.get(API_URL + '/find/' + state.search, {
                  headers: {token: state.token},
              });
          } catch (error) {
              router.push('/error');
          }
          commit('setProgress', false);
          state.results = results.data;

          router.push('/results');
        },
        getDays: async ({state, commit}) => {
            commit('setDays', []);
            let days = null;
            try {
                days = await Vue.axios.get(API_URL + '/days', {
                    headers: {token: state.token},
                });
            } catch (error) {
                router.push('/error');
            }
            commit('setProgress', false);
            commit('setDays', days.data);
        },
        getSessions: async ({state, commit}, params) => {
            commit('setSessions', []);
            let sessions = null;
            try {
                sessions = await Vue.axios.get(API_URL + '/days/' + params.id, {
                    headers: {token: state.token},
                });
            } catch (error) {
                router.push('/error');
            }
            commit('setProgress', false);
            commit('setSessions', sessions.data);
        },
        getPresentations: async ({state, commit}, params) => {
            commit('setPresentations', []);
            let presentations = null;
            try {
                presentations = await Vue.axios.get(API_URL + '/sessions/' + params.id, {
                    headers: {token: state.token},
                });
            } catch (error) {
                router.push('/error');
            }
            commit('setProgress', false);
            commit('setPresentations', presentations.data[0].presentations);
        },
        sendInvitation: async ({state, commit}, params) => {
            try {
                await Vue.axios.post(API_URL + '/persons', {
                    session: params.session.id,
                    presentation: params.presentation.id,
                    person: params.person.id,
                    meeting: params.meeting,
                    controller: params.controller,
                    support: params.support,
                }, {
                    headers: {token: state.token},
                });
            } catch (error) {
                router.push('/error');
            }
            commit('setProgress', false);
        },confirm: async (state, message) => {
            let result = await confirm(message);
            if (result) {
                return ''
            } else {
                throw new Error('cancelled')
            }
        },

        setComment: async ({state, commit}, params) => {
            try {
                console.log(params, state.token)
                await Vue.axios.put(API_URL + params.type + '/' + params.id, {
                    director_comment: params.comment,
                }, {
                    headers: {token: state.token},
                });
            } catch (error) {
                router.push('/error');
            }
            commit('setProgress', false);
        }
    },
    modules: {
        videoUpload
    }
})
